<template>
  <div>
    <h2 v-if="false">[MAP]</h2>
    <h5>Contact Information</h5>
        <p>
          <b-icon
              icon="geo-alt"
          />
          {{address1}} {{city}}, {{state}} {{zip}}
        </p>
        <p v-if="phone">
          <b-icon
              icon="telephone"
          />
          {{phone}}
        </p>
    <h5>Websites and Social Links</h5>
        <p v-if="email">
          <b-icon
              icon="mail"
          />
          {{email}}
        </p>
        <p v-if="url">
          <b-icon
              icon="globe2"
          />
          <b-link>
            {{url}}
          </b-link>
        </p>
        <p>
          <b-icon
              v-if="social.facebook && social.facebook.url && social.facebook.isShown"
              icon="facebook"
              @click="handleGoToSocial(`fb`,`https://facebook.com/${social.facebook.url}`)"
          />
          <b-icon
              v-if="social.instagram && social.instagram.url && social.instagram.isShown"
              style="margin-left: 15px"
              icon="instagram"
          />
          <b-icon
              v-if="social.linkedin && social.linkedin.url && social.linkedin.isShown"
              style="margin-left: 15px"
              icon="linkedin"
          />
          <b-icon
              v-if="social.twitter && social.twitter.url && social.twitter.isShown"
              style="margin-left: 15px"
              icon="twitter"
          />
        </p>
  </div>
</template>

<script>
export default {
  name: "Provider_Site_ABOUT",
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  computed: {
    organizationName() {
      return this.provider && this.provider.info && this.provider.info.name ?
          this.provider.info.name : null;
    },
    orgDescription() {
      return this.provider && this.provider.info && this.provider.info.descriptioo ?
          this.provider.info.description : null;
    },
    address1() {
      return this.provider && this.provider.info && this.provider.info.address1 ?
          this.provider.info.address1 : null;
    },
    city() {
      return this.provider && this.provider.info && this.provider.info.city ?
          this.provider.info.city : null;
    },
    state() {
      return this.provider && this.provider.info && this.provider.info.state ?
          this.provider.info.state : null;
    },
    phone() {
      return this.provider && this.provider.info && this.provider.info.phone ?
          this.provider.info.phone : null;
    },
    email() {
      return this.provider && this.provider.email && this.provider.info.email ?
          this.provider.info.email : null;
    },
    zip() {
      return this.provider && this.provider.info && this.provider.info.zip ?
          this.provider.info.zip : null;
    },
    url() {
      return this.provider && this.provider.info && this.provider.info.url ?
          this.provider.info.url : null;
    },
    social() {
      return this.provider && this.provider.social ?
          this.provider.social : null;
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleGoToSocial(socialType, socialURL){
      window.open(socialURL, "_blank");
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
